import { render } from "./AttachmentUploadIcon.vue?vue&type=template&id=7b929e56"
import script from "./AttachmentUploadIcon.vue?vue&type=script&lang=js"
export * from "./AttachmentUploadIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__